import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { NavigationEnd, Router } from '@angular/router';
import { BaseProviderService } from './base-provider.service';
import { Notificacao } from '../aplicacao/models/notificacao.model';

@Injectable({
  providedIn: 'root'
})
export class NotificacoesService extends BaseProviderService {
  protected module = 'NotificacaoParceiro';

  private notificacoesSubject = new BehaviorSubject<Notificacao[]>([]);
  public notificacoes$ = this.notificacoesSubject.asObservable();

  private carregando = false;

  constructor(protected http: HttpClient, private router: Router) {
    super(http);
    // Carregamento automático: sempre que a rota atual estiver dentro de "area-parceiro/".
    // Também é disparado manualmente: (1) após o login e (2) ao clicar no ícone do sino.
    this.router.events
      .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
      .subscribe(e => {
        const url = (e.urlAfterRedirects || e.url || '').toLowerCase();
        if (url.includes('/area-parceiro/') || url.startsWith('/area-parceiro')) {
          this.recarregar();
        }
      });
  }

  /** GET /api/V1/NotificacaoParceiro/listar */
  listar(): Observable<Notificacao[]> {
    return this.http.get<any[]>(this.getUrl(this.v1, this.module, ['listar']))
      .pipe(map(res => (res || []).map(n => this.normalizar(n))));
  }

  /** Normaliza a notificação aceitando variações de casing vindas da API (.NET PascalCase, etc.) */
  private normalizar(n: any): Notificacao {
    if (!n) return n;
    const normalizada: any = {
      id: n.id ?? n.Id,
      mensagem: n.mensagem ?? n.Mensagem,
      dataCriacao: n.dataCriacao ?? n.DataCriacao,
      documentoCredor: n.documentoCredor ?? n.DocumentoCredor,
      credor: n.credor ?? n.Credor,
      visualizado: n.visualizado ?? n.Visualizado ?? false,
      fase: n.fase ?? n.Fase,
      propostaId: n.propostaId ?? n.PropostaId ?? n.proposta_id ?? n.idProposta ?? n.IdProposta
    };
    return normalizada as Notificacao;
  }

  /** Dispara o carregamento e publica no BehaviorSubject (compartilhado entre componentes) */
  recarregar(): void {
    if (this.carregando) return;
    this.carregando = true;
    this.listar().subscribe({
      next: notifs => {
        console.log('[NotificacoesService] notificações recebidas:', notifs);
        this.notificacoesSubject.next(notifs);
        this.carregando = false;
      },
      error: () => { this.carregando = false; }
    });
  }

  /** POST /api/V1/NotificacaoParceiro/notificar - marca uma notificação como visualizada/notificada */
  notificar(notificacaoParceiroId: string): Observable<any> {
    return this.http.post(
      this.getUrl(this.v1, this.module, ['notificar']),
      { notificacaoParceiroId }
    );
  }
}


